<template>
  <button @click="onCopy">
    <transition name="fade" mode="out-in">
      <span :key="`copy:${isCopying}`" class="copy">
        <span v-if="isCopying" class="copied" key="copied">Copied!</span>
        <slot v-else />
      </span>
    </transition>
  </button>
</template>

<script>
const Clipboard = require('clipboard');

export default {
  data() {
    return {
      isCopying: false,
    };
  },
  mounted() {
    const clipboard = new Clipboard(this.$el);

    clipboard.on('success', () => {
      this.isCopying = true;
      setTimeout(() => {
        this.isCopying = false;
      }, 2000);
    });
  },

  methods: {
    onCopy() {
      this.$emit('copy');
    },
  },
};
</script>
